import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "What's the #1 most effective way to manage and optimize cloud costs?",
    answer: `<p>A straightforward approach to optimizing cloud costs is to identify and eliminate unused or underutilized resources. Common situations where these resources accumulate include developers provisioning temporary compute instances and then forgetting to remove them.</p>`,
  },
  {
    question: "What is a cloud cost strategy?",
    answer: `<p>Cloud cost management, also referred to as cloud cost optimization, involves organizational planning that enables an enterprise to comprehend and control the expenses and requirements tied to its cloud technology. Specifically, this entails discovering cost-efficient methods to enhance cloud usage and efficiency.</p>`,
  },
  {
    question: "Why is cloud cost management so difficult?",
    answer: `<p>Predicting cloud expenses can be difficult, especially with multiple cloud resources. Changes in your plans or additional tasks can quickly increase costs. An inaccurate budget forecast can significantly impact the management of cloud expenses.</p>`,
  },
  {
    question: "What are the pricing strategies for cloud services?",
    answer: `<p>The following are the most crucial aspects that providers use to calculate pricing for cloud services:</p>
    <ul>
    <li>Type of cloud service</li>
    <li>Provider's business model</li>
     <li>Market competition and demand</li>
      <li>Level of user engagement with the service</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Cost Optimization FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
